<div class="">
  <div class="custella-modal d-flex flex-column">
    <div class="custella-modal-header align-items-center">
      <div class="custella-modal-header-text">
        <span>{{translate?.general.buttons.update.singular}}&nbsp;{{translate?.general.messages.confirmation}}</span>
      </div>
      <i class="fa-regular fa-xmark fa-lg" [pTooltip]="translate?.general.buttons.close.singular" tooltipPosition="left"
        (click)="modalRef.hide()"></i>
    </div>
    <div class="custella-modal-body p-0">
      <div class="custella-form-container box-none m-0">
        <div class="custella-form-container-title-two-grey fst-italic ps-4">
          <span class="text-12 font-medium d-block">{{translate?.asset.messages.wouldYouAlsoLikeToUpdate}}</span>
        </div>

        <div class="custella-content-row mx-4">
          <div class="custella-content-row-input col-12">
            <div class="d-flex flex-column gap-2">
              <div class="flex-align-baseline gap-2">
                <div class="p-field-checkbox"><p-checkbox [binary]="true" [(ngModel)]="updateChildAssetsAddress"></p-checkbox></div>
                <span class="text-12">{{ translate?.general.locationDetails.fields.address.singular }}</span>
              </div>
              <div class="flex-align-baseline gap-2">
                <div class="p-field-checkbox"><p-checkbox [binary]="true" [(ngModel)]="updateChildAssetsCustodian"></p-checkbox></div>
                <span class="text-12">{{ translate?.asset.fields.custodian.singular }}</span>
              </div>
              <div class="flex-align-baseline gap-2">
                <div class="p-field-checkbox"><p-checkbox [binary]="true" [(ngModel)]="updateChildAssetsCustomer"></p-checkbox></div>
                <span class="text-12">{{ translate?.customer.label.singular }}</span>
              </div>
              <div class="flex-align-baseline gap-2">
                <div class="p-field-checkbox"><p-checkbox [binary]="true" [(ngModel)]="updateChildAssetsServiceZone"></p-checkbox></div>
                <span class="text-12">{{ translate?.setup.serviceZone.label.singular }}</span>
              </div>
               <div class="flex-align-baseline gap-2">
                <div class="p-field-checkbox"><p-checkbox [binary]="true" [(ngModel)]="updateChildAssetsStatus"></p-checkbox></div>
                <span class="text-12">{{translate?.asset.messages.alsoUpdateComponentStatus}}</span>
              </div>

            </div>
          </div>
        </div>

        <div class="custella-content-row ms-4">
          <div class="custella-content-row-input col-12">
            <div class="custella-content-row-input-title-three fst-italic">{{translate?.asset.messages.respectiveFieldsOverridden}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="custella-modal-footer flex-align-center justify-content-end">
      <button type="button" class="custella-btn-white text-12 ms-2"
        (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
      <p-button type="button" [label]="translate?.general.buttons.update.singular" styleClass="ms-2 h-32" (onClick)="onSubmit()"></p-button>
    </div>
  </div>
</div>